import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import Paper from '@material-ui/core/Paper';
import PageContainer from './PageContainer';
import Button from '../atoms/Button';
import SearchPlayers from '../organisms/SearchPlayers';
import FilterIcon from '../icons/FilterIcon';
import SearchPlayersIcon from '../icons/SearchPlayersIcon';
import { COLOR_BLACK, COLOR_BLUE, COLOR_TEXT } from '../styles/colors';
import MEDIA from '../styles/media';
import { Link as MuiLink } from '@material-ui/core';
import { State } from '../redux/reducers';
import User from '../types/User';
import gql from '../services/gql';
import { PlayerAccessSummary } from '../types/AccessLevel';
import { PlayerType, ResetFiltersState } from '../types/PlayerType';
import DropDown, { DropDownItem } from '../atoms/DropDown';
import { COLLEGE_LEVELS, NFL_OPTIONS } from '../services/search';
import clsx from 'clsx';
import { generateYearRange, getMaxHighSchoolClassYear } from '../services/user';

let collegeLevelList: DropDownItem[] = COLLEGE_LEVELS.map(item => ({
  value: item.value,
  content: item.content,
}));

const nflPlayersList: DropDownItem[] = NFL_OPTIONS.map(item => ({
  value: item.value,
  content: item.content,
}));

const useStyles = makeStyles(theme => ({
  searchPageTemplate: {
    minHeight: '100vh',
  },
  paper: {
    width: '100%',
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  header: {
    alignItems: 'center',
    color: COLOR_TEXT,
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(3, 4, 0),
  },
  headerTitle: {
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    ...theme.typography.h2,
  },
  headerIcon: {
    width: '32px',
    height: '32px',
    marginRight: theme.spacing(1),
  },

  searchPlayer: {
    padding: theme.spacing(2,4,4,4),
  },

  filterBtn: {
    width: '118px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  filterIcon: {
    height: '32px',
    width: '32px',
    marginRight: theme.spacing(1),
  },

  filterDrawer: {
    width: '90%',
    maxWidth: '440px',
  },
  drawerHeader: {
    display: 'flex',
    minHeight: '70px',
    padding: theme.spacing(2),
    alignItems: 'center',
  },
  drawerContent: {
    padding: theme.spacing(4, 0),
  },
  closeButton: {
    marginLeft: 'auto',
  },

  filterWrapper: {
    fontSize: theme.typography.pxToRem(16),
    marginBottom: theme.spacing(4),
    padding: theme.spacing(0, 4),

    '&:last-of-type': {
      marginBottom: theme.spacing(0),
    },
  },
  filterContent: {
    padding: theme.spacing(4, 0),
  },
  filterTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
  dropdown:{
    height: '50px',
    width: '100%',
  },

  checkboxWrap: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  checkbox: {
    marginRight: theme.spacing(1),
  },

  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(4),
  },
  action: {
    height: '50px',
    width: '170px',
    marginRight: theme.spacing(2),
  },

  [MEDIA.MOBILE]: {
    header: {
      margin: theme.spacing(2),
    },

    searchPlayer: {
      padding: theme.spacing(2),
    },
  },
  statItem: {
    alignItems: 'center',
    display: 'flex', 
    // flexDirection: 'column',
    fontSize: '0.9rem', 
    fontWeight: 600, 
    marginBottom: '0.5rem', 
  },
  statsCountLink: {
    appearance: 'none',
    background: 'none',
    border: 0,
    color: COLOR_BLUE,
    cursor: 'pointer',
    lineHeight: 1,
    margin: 0,
    padding:  theme.spacing(0, 1),
    textDecoration: 'underline',

    '&:hover': {
      textDecoration: 'underline',
    },
  },
  statsCountText: {
    color: COLOR_BLACK,
    cursor: 'default',
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'none',
    },
  },
  dropDown: {
    width: '100%',
  }
}), { name: SearchPageTemplate.name });

export function SearchPageTemplate (props: {user?: User, isNFL: boolean, currentRecruitingYear: number, adminAccess: boolean}) {
  const {
    user,
    isNFL,
    currentRecruitingYear,
    adminAccess
  } = props;
  const classes = useStyles();
  const history = useHistory();
  const { searchId } = useParams<any>();
  const [resetFiltersOnStatsCounts, setResetFiltersOnStatsCounts] = useState<ResetFiltersState | null>({
    playerType: null,
    reset: false,
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [playerAccessSummary, setPlayerAccessSummary] = useState<PlayerAccessSummary | null>(null);
  const [hsClassYearList, setHsClassYearList] = React.useState<DropDownItem[] | null>(null);
  const [selectedHsClassYear, setSelectedHsClassYear] = React.useState<string | null>(null);
  const [selectedCollegeTeam, setSelectedCollegeTeam] = React.useState<string | null>(null);
  const [selectedNflPlayerType, setSelectedNflPlayerType] = React.useState<string | null>(null);
  
  function getHsClassYearsForAccess(user: any): DropDownItem[] {
    let graduatingClasses: any[] = [];
    const maxHighSchoolClassYear = getMaxHighSchoolClassYear(user, currentRecruitingYear);
    if (maxHighSchoolClassYear) {
      const currentYear = currentRecruitingYear;
      const AllGradYears = generateYearRange(
        currentYear,
        currentYear + (adminAccess ? 5 : 4)
      );
      
      const userGradYears = generateYearRange(
        currentYear,
        maxHighSchoolClassYear
      );

      graduatingClasses = AllGradYears.map((item: any) => {
          return {
            value: item,
            content: item,
            isDisabled: !userGradYears.includes(item),
          }
        });        
    }

    setHsClassYearList(graduatingClasses);
    return graduatingClasses;
  }

  useEffect(() => {
    if (!user?.accessLevel?.hasCollegeAccess && user?.accessLevel?.hasJucoAccess) {
      collegeLevelList = collegeLevelList.filter(item => item.value == 'JUCO');
    }
    fetchPlayerAccessSummary();
  }, []);

  // get hs class year list
  useEffect(() => {
    if (user?.accessLevel?.name) {
      getHsClassYearsForAccess(user)
    }
  }, [user])

  function fetchPlayerAccessSummary () {
    return gql(`
      getPlayerAccessSummary {
        hsPlayersCount
        collegePlayersCount
        nflPlayersCount
      }
    `)
    .then((data:any) => data.getPlayerAccessSummary as PlayerAccessSummary)
    .then((playerAccessSummary:PlayerAccessSummary) => {
      if (playerAccessSummary) {
        setPlayerAccessSummary(playerAccessSummary);
      }
    })
    .catch(console.error);
  };

  function formatNumber(value: number): string {
    if (isNaN(value)) return "0";
    return new Intl.NumberFormat("en-US").format(value);
  }

  const handleStatsCountClick = (playerType: PlayerType, reset = true): void => {
    setResetFiltersOnStatsCounts({
      reset: reset,
      playerType: playerType,
    });
  };

  const handleDropDownChange = (playerType: PlayerType, value: string) => {
    // console.log('playerType', playerType);
    // console.log('value', value);
    let url = `?quick-filter=true`;
    if (playerType === "high-school") {
      setSelectedCollegeTeam(null);
      setSelectedNflPlayerType(null);
      setSelectedHsClassYear(value ? value : 'all');
      history.push(`${url}&hs-class-year=${value ? value : 'all'}`);
    } else if (playerType === "college") {
      setSelectedHsClassYear(null);
      setSelectedNflPlayerType(null);
      setSelectedCollegeTeam(value);
      history.push(`${url}&level=${value ? value : 'none'}`);
    } else if (playerType === "nfl") {
      setSelectedHsClassYear(null);
      setSelectedCollegeTeam(null);
      setSelectedNflPlayerType(value ? value : 'all');
      url = `${url}&nfl-player-type=${value ? value : 'all'}`;
      history.push(url);
    }
  };

  return (
    <PageContainer className={classes.searchPageTemplate}>
      <Paper className={classes.paper}>
        <div className={classes.header}>
          <h1 className={classes.headerTitle}>
            <SearchPlayersIcon  className={classes.headerIcon} />
            Search Players
          </h1>

          <div style={{ display: 'flex', gap: '8px' }}>
            {
              !isNFL && (
              <div>
                <div className={classes.statItem}>
                  <span>Active HS Players: </span>
                  <MuiLink
                    className={clsx(classes.statsCountLink)}
                    component="span"
                    onClick={() => handleStatsCountClick("high-school")}
                  >
                    {
                      playerAccessSummary?.hsPlayersCount && (playerAccessSummary?.hsPlayersCount) > 0 
                        ? formatNumber(playerAccessSummary?.hsPlayersCount) 
                        : 0
                    }
                  </MuiLink>
                </div>
                <DropDown 
                  className={classes.dropDown}
                  items={hsClassYearList || []} 
                  value={selectedHsClassYear} 
                  emptyItem={{
                    value: null,
                    content: 'HS Class'
                  }}
                  onChange={(value: any) => handleDropDownChange("high-school", value)}
                  labelWhenSelectedAll='All'
                  labelWhenSelectedNone='All'
                />
              </div>

              )
            }
            {user?.accessLevel?.hasCollegeAccess || user?.accessLevel?.hasJucoAccess ? <div>
              <div className={classes.statItem}>
                <span>College: </span>
                <MuiLink
                  className={clsx(classes.statsCountLink, classes.statsCountText)}
                  component="span"
                >
                  {
                    playerAccessSummary?.collegePlayersCount && playerAccessSummary?.collegePlayersCount > 0 
                      ? formatNumber(playerAccessSummary?.collegePlayersCount) 
                      : 0
                  }
                </MuiLink>
              </div>
              <DropDown
                className={classes.dropDown}
                items={collegeLevelList}
                value={selectedCollegeTeam}
                onChange={(value: any) => handleDropDownChange("college", value)}
                placeholder={"Level"}
              />
            </div> : ''}
            {user?.accessLevel?.hasNFLAccess ? <div>
              <div className={classes.statItem}>
                <span>NFL: </span>
                <MuiLink
                  className={classes.statsCountLink}
                  component="span"
                  onClick={() => handleStatsCountClick("nfl")}
                >
                  {
                    playerAccessSummary?.nflPlayersCount && playerAccessSummary?.nflPlayersCount > 0 
                      ? formatNumber(playerAccessSummary?.nflPlayersCount) 
                      : 0
                  }
                </MuiLink>
              </div>
              <DropDown
                className={classes.dropDown}
                items={nflPlayersList}
                value={selectedNflPlayerType}
                onChange={(value: any) => handleDropDownChange("nfl", value)}
                emptyItem={{
                  value: null,
                  content: 'Players'
                }}
                labelWhenSelectedNone='All'
                labelWhenSelectedAll='All'
              />
            </div> : ''}
          </div>

          <div style={{ alignItems: 'center', display: 'flex' }}>
            <Button
            className={classes.filterBtn}
            primary
            onClick={() => setIsDrawerOpen(true)}
          >
            <FilterIcon className={classes.filterIcon}/>
            Filter
          </Button>
          </div>
        </div>

        <SearchPlayers
          className={classes.searchPlayer}
          searchId={Number(searchId)}
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={(value: boolean) => setIsDrawerOpen(value)}
          onResetFiltersOnStatsCounts={handleStatsCountClick}
          resetFiltersOnStatsCounts={resetFiltersOnStatsCounts}
        />
      </Paper>
    </PageContainer>
  );
}


const mapStateToProps = (state:State) => {
  return {
    user: state.user,
    isNFL: state.ui.nflAccess,
    currentRecruitingYear: state.configurations.currentRecruitingYear,
    adminAccess: state.ui.adminAccess
  };
};

const mapDispatchToProps =  (dispatch:Dispatch) => {
  return bindActionCreators(
    {},
    dispatch
  )
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchPageTemplate);
